import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@ui/dialog.tsx';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import { AddPointForm } from './add-point-form.tsx';

interface AddPointDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
  fixedCompany?: { id: number; uniqueCode: string; name: string };
}

export const AddPointDialog: FC<AddPointDialogProps> = ({
  isOpen,
  onOpenChange,
  onSuccess,
  fixedCompany
}) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onOpenChange(false);
    onSuccess?.();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="p-0 max-w-2xl overflow-hidden"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="p-14 max-h-[90vh] overflow-y-auto scrollable">
          <DialogHeader>
            <DialogTitle className="text-2xl">{t('common.add.point')}</DialogTitle>
            <DialogDescription>{t('admin.points.add.dialog.description')}</DialogDescription>
            <p className="text-sm text-muted-foreground mt-1">
              {t('admin.points.add.form.required.fields')}
            </p>
          </DialogHeader>
          <div className="mt-6">
            <AddPointForm onSuccess={handleSuccess} fixedCompany={fixedCompany} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
